import { render, staticRenderFns } from "./ReporteParosNoAtendidos.vue?vue&type=template&id=4ef5e6d4&"
import script from "./ReporteParosNoAtendidos.vue?vue&type=script&lang=js&"
export * from "./ReporteParosNoAtendidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports